import { useLocation } from "react-router-dom";
import { CourseProgress } from "../../components/CourseProgress"
import { TitleBar } from "../../components/TitleBar"


export const StudentProgress = () => {
    const location = useLocation();
    const { id, name, classTitle, classId, courseId } = location.state || {};


    return (
        <>
            <div className="p-4 min-h-screen">
                <TitleBar
                    title={name}
                    subTitle={classTitle}
                    isBackTo={true}
                    backPath="/teacher/class/students"
                    backState={{ id: classId, title: classTitle, selectedSideBar: 1 }}
                    backToTitle="Back to Students"
                />
                <div className="w-full py-8">
                    <CourseProgress courseId={courseId} userId={id} />
                </div>
            </div>
        </>
    )
}